import { isNumber, isUndefined } from 'lodash'

import chapters from '@/config/chapters'

const resetChapters = (state) => {
  state.currentChapter = null
  return state
}

export default {

  state: resetChapters({}),

  getters: {

    hasSavedGame ({ currentChapter }) {
      return isNumber(currentChapter)
    },

    currentChapter ({ currentChapter }) {
      return currentChapter
    }

  },

  mutations: {

    resetChapters,

    setCurrentChapter (state, i) {
      state.currentChapter = i
    }

  },

  actions: {

    resetChapterState ({ commit }) {
      commit('resetFiles')
      commit('resetInGameTime')
      commit('resetInventory')
      commit('resetPlayer')
      commit('resetRadios')
      commit('resetRadioTransmittions')

      // Not resetting these so user can keep their content
      // commit('resetNotebook')
      // commit('resetUserPreferences')
    },

    resetUserProgress ({ commit }) {
      commit('resetChapters')
      commit('resetNotebook')
    },

    resetUserPreferences ({ commit }) {
      commit('resetUserPreferences')
    },

    initializeChapterState ({ dispatch }, {
      files,
      inGameDay,
      inGameHours,
      inGameMinutes,
      inventoryItems,
      playerLocationX,
      playerLocationY,
      radios
    }) {
      // In-game time
      if (!isUndefined(inGameDay)) {
        dispatch('setInGameDay', inGameDay)
      }

      if (!isUndefined(inGameHours) || !isUndefined(inGameMinutes)) {
        dispatch('setInGameTime', {
          hours: inGameHours,
          minutes: inGameMinutes
        })
      }

      // Load files
      if (files && files.length) {
        files.forEach((fileSlug) => {
          dispatch('spawnFile', fileSlug)
        })
      }

      // Load inventory items
      if (inventoryItems && inventoryItems.length) {
        inventoryItems.forEach((inventoryItem) => {
          dispatch('spawnInventoryItem', inventoryItem)
        })
      }

      // Move player
      if (
        !isUndefined(playerLocationX) ||
        !isUndefined(playerLocationY)
      ) {
        dispatch('movePlayerTo', {
          x: playerLocationX,
          y: playerLocationY
        })
      }

      // Load world radios
      if (radios && radios.length) {
        radios.forEach((radio) => {
          dispatch('spawnRadio', radio)
        })
      }
    },

    initializeChapterStateFromBeginning ({ commit, dispatch }, chapterNumber) {
      dispatch('resetChapterState')

      for (let i = 0; i < Math.min(chapterNumber + 1, chapters.length); i++) {
        dispatch('initializeChapterState', chapters[i].state)
      }

      commit('setCurrentChapter', chapterNumber)
    }

  }

}
